import styled from 'styled-components';

export default styled.div`
  position: relative;
  border-top: 1px solid rgba(90, 100, 119, 0.4);
  margin: 0 10px 10px;
  padding: 5px 0;
`;
